import React, { useState } from "react";
import { getIconByChannel } from "../../../../utils/getIconByChannel";
import { renderAvaliation } from "../../../../utils/renderAvaliation";
import { Tooltip } from "@mui/material";
import {
  changeDisplayByeChat,
  formatarNomeDoContato,
} from "../../../../actions/websocket";
import UserPhoto from "../../../UserPhoto/userphoto";
import { deleteEmailMsg } from "../../../../actions";
import { CallRemove } from "iconsax-reactjs";

import { ReactComponent as IconConsultTransfer } from "../../../../build/images/attendanceIcons/arrow-swap.svg";
import { ReactComponent as Anotacoes } from "../../../../build/images/popover-queue/edit-2.svg";
import { ReactComponent as IconSearchChat } from "../../../../build/images/attendanceIcons/search-normal.svg";
import { ReactComponent as InfoCircle } from "../../../../build/images/info-circle.svg";
import { ReactComponent as DefaultIcon } from "../../../../build/images/new-monitoring-modal/Group 14196.svg";
import { ReactComponent as SussurroIcon } from "../../../../build/images/viewactionprofile.svg";
import { ReactComponent as PointMessageIcon } from "../../../../build/images/viewactionmessagepoint.svg";
import { ReactComponent as SEND } from "../../../../build/images/send-2.svg";
import { ReactComponent as AnexarItem } from "../../../../build/images/paperclip.svg";
import { ReactComponent as MensagemPredefinidas } from "../../../../build/images/message-text.svg";
import { ReactComponent as IconAudio } from "../../../../build/images/microphone-2.svg";

import MoreOptionsPopoverV2 from "../../../MoreOptionsPopoverV2/MoreOptionsPopoverV2";
import Typography from "../../../Typography";
import MailContainer from "../../../mail-section/MailContainer";
import MessageList from "../../../ChatRenderer/ChatRenderer";
import AudioWaveform from "../../../AudioVisualizer/AudioWaveform";
import { Tooltippy } from "../../../../actions/Tippy";
import QuickAnswer from "../../../../containers/QuickAnswer";
import TimeCounter from "../../../../containers/TimeCounter";
import { useMessageContainer } from "./hooks/useMessageContainer";

const MessageContainer = ({
  selectedChat,
  setSelectedChat,
  setMonitorMessage,
  changeDisplayTransfer,
  ViewAnotations,
  setOpenSearch,
  openDetails,
  setOpenDetails,
  openSearch,
  getTermText,
  searchText,
  searchWord,
  setSearchText,
  setSearchWord,
  monitorMessage,
  hasVoice,
  typeMonitoring,
  setIsRecording,
  Mp3Recorder,
  setBlobURL,
}) => {
  let valorInput = "";

  const {
    Monitoring,
    handleKeyPress,
    handleKeyDown,
    handleOnChange,
    InfoUsers,
    DisplayQuickAnswer,
    InsertQuickAnswer,
    filterList,
    respostasinicial,
    handleselectedFile,
    audioStart,
    audioStop,
    audioStopIn,
    ButtonSendMessage,
    MailMessage,
    dispatch,
    handleAddContact,
    handleKeyUp,
    record,
    buttonQuickAnswer,
    respostas,
    messageQuickAnswer,
    changeVariablesSending,
    variableQuickAnwser,
    actionSendMessageClient,
    actionCancelMessageClient,
    sendTextInputChat,
    timerecording,
    createJSON,
    sendMesssageV2,
  } = useMessageContainer(
    setIsRecording,
    Mp3Recorder,
    setBlobURL,
    setSearchWord,
    searchWord
  );
  const renderInputChat = () => {
    if (typeMonitoring === 2 || typeMonitoring === 3) {
      if (
        (selectedChat &&
          parseInt(selectedChat.idmidia) !== 3 &&
          parseInt(selectedChat.idmidia) !== 1) ||
        !selectedChat
      ) {
        return (
          <div className="message-box">
            <div className="input-message">
              {(() => {
                if (Monitoring.line === "2") {
                  return (
                    <div className="monitoria-icon">
                      <SussurroIcon />
                    </div>
                  );
                } else if (Monitoring.line === "3") {
                  return (
                    <div className="monitoria-icon">
                      <PointMessageIcon />
                    </div>
                  );
                }
              })()}
              <div
                onKeyPress={handleKeyPress}
                autoComplete="off"
                type="text"
                // ref={(node) => (this.node = node)}
                onInput={(e) => (valorInput = e.target.innerText)}
                onKeyDown={handleKeyDown}
                onKeyUp={(event) =>
                  handleOnChange(
                    event,
                    InfoUsers,
                    selectedChat,
                    Monitoring.line
                  )
                }
                className="chat-message"
                id="chat-message"
                contentEditable="true"
              ></div>
              <div className={record ? "actions-chat" : "actions-chat active"}>
                <a
                  onClick={(e) => DisplayQuickAnswer(e)}
                  className={`btn action with-icon ${
                    buttonQuickAnswer ? "active" : ""
                  } `}
                  id="action-premade-messages"
                  data-tippy="Mensagens predefinidas"
                  href="#"
                >
                  <MensagemPredefinidas />
                </a>
                <div
                  className={
                    buttonQuickAnswer ? "premade-msg active" : "premade-msg"
                  }
                >
                  <p className="premade-msg__title">Mensagens Predefinidas</p>
                  <div className="premade-msg__content">
                    <ul className="premade-msg__list">
                      {respostas.map((resp) => (
                        <li
                          key={resp.qck_asw_id}
                          className="premade-msg__item"
                          onClick={(event) =>
                            InsertQuickAnswer(
                              event,
                              resp.qck_asw_answer,
                              resp.editable,
                              resp.mimetypeid,
                              resp.filepath,
                              InfoUsers,
                              selectedChat
                            )
                          }
                        >
                          {resp.qck_asw_keyword}
                        </li>
                      ))}
                    </ul>
                    <div className="premade-msg__input-wrapper">
                      <input
                        type="text"
                        className="premade-msg__search-input"
                        id="input-msgs-rapidas"
                        onChange={(event) =>
                          filterList(event, respostasinicial)
                        }
                        placeholder="Pesquise uma resposta..."
                      />
                      <span className="premade-msg__input-icon">
                        <i className="material-icons">search</i>
                      </span>
                    </div>
                  </div>
                </div>
                <QuickAnswer
                  message={messageQuickAnswer}
                  variables={variableQuickAnwser}
                  sendTextInputChat={sendTextInputChat}
                  actionSendMessageClient={actionSendMessageClient}
                  actionCancelMessageClient={actionCancelMessageClient}
                  changeVariablesSending={changeVariablesSending}
                  screen="monitoring"
                  bind={this}
                />
                <a
                  href="#"
                  className="btn action with-icon chat-special tippy-default"
                  data-tippy-theme="light"
                  id="action-attachment"
                  data-tippy-content="Adicionar Anexo"
                >
                  <label htmlFor="file-input">
                    <AnexarItem />
                    {/* attach_file */}
                  </label>
                  <input
                    style={{ display: "none" }}
                    type="file"
                    name="upload"
                    id="file-input"
                    onChange={(event) =>
                      handleselectedFile(
                        event,
                        InfoUsers,
                        selectedChat,
                        Monitoring.line
                      )
                    }
                  />
                </a>
                <Tooltippy content={"Enviar Áudio"}>
                  <button
                    href="#"
                    onClick={audioStart}
                    disabled={!InfoUsers.sending_audio}
                    className="btn action with-icon"
                    id="action-voice"
                    data-tippy="Atender em voz"
                  >
                    <IconAudio />
                  </button>
                </Tooltippy>
              </div>
              <div className={record ? "active-voice active" : "active-voice"}>
                <a onClick={audioStop} className="cancel">
                  <i className="material-icons">close</i>
                </a>

                <div className="active-chats__timer active-chats__timer--active-voice">
                  {(() => {
                    if (record === true)
                      return (
                        <>
                          <span className="active-chats__timer-icon active-chats__timer--active-voice-icon alta">
                            •
                          </span>
                          <TimeCounter horario={timerecording} />
                        </>
                      );
                  })()}
                </div>

                <a onClick={audioStopIn} className="done">
                  <i className="material-icons">done</i>
                </a>
              </div>
            </div>

            <button
              type="submit"
              onClick={(event) => {
                try {
                  // ButtonSendMessage(
                  //   event,
                  //   "Me",
                  //   InfoUsers,
                  //   selectedChat,
                  //   "0",
                  //   Monitoring.line
                  // )
                  sendMesssageV2(
                    event,
                    InfoUsers,
                    selectedChat,
                    Monitoring.line
                  );
                } catch (error) {
                  console.log(error);
                }
              }}
              className="send-message"
              id="button-send-message"
            >
              {/* <i className="material-icons">send</i> */}
              <SEND />
            </button>
          </div>
        );
      }
    }

    return "";
  };
  const renderChat = () => {
    if (selectedChat && parseInt(selectedChat.idmidia) === 3) {
      return MailMessage.filter(
        (message) => message.cdr === selectedChat.idatendimento
      ).map((mail) => (
        <MailContainer
          mail={mail}
          inputSearch={searchText}
          canFavorite={false}
        />
      ));
    } else if (monitorMessage.length > 0) {
      return (
        <MessageList
          arrayMessage={monitorMessage}
          selectedChat={selectedChat}
          agent={Monitoring.agent}
          searchText={searchText}
          handleAddContact={handleAddContact}
          canSaveContact={false}
        />
      );
    } else if (hasVoice && parseInt(selectedChat.idmidia) === 1) {
      return <AudioWaveform />;
    } else {
      return <p></p>;
    }
  };

  return (
    <div
      className="chat-container monitoring-dashboard-v2__main-content__chat-container"
      style={{ width: "68%", height: "100%" }}
    >
      {Boolean(selectedChat) && (
        <div className="monitoring-dashboard-v2__main-content__chat-container__header">
          <div className="monitoring-dashboard-v2__main-content__chat-container__header__user-information-container">
            <div className="chats-content__body__icon" onClick={() => {}}>
              <UserPhoto
                size="large"
                letterIcon={createJSON(selectedChat.cliente.trim())}
              />
              <div className="chats-content__body__icon__media">
                {getIconByChannel(selectedChat.idmidia)}
              </div>
            </div>
            <div className="monitoring-dashboard-v2__main-content__chat-container__header__user-information-container__user-name">
              <h3>{createJSON(formatarNomeDoContato(selectedChat.cliente))}</h3>
              <div className="monitoring-dashboard-v2__main-content__chat-container__header__user-information-container__user-name__avaliation">
                {renderAvaliation(selectedChat)}
              </div>
            </div>
          </div>
          {Boolean(selectedChat) && selectedChat.idatendimento !== "voice" && (
            <div className="monitoring-dashboard-v2__main-content__chat-container__header__actions-container">
              <Tooltip
                title={
                  <span style={{ fontSize: "12px" }}>Encerrar chamada</span>
                }
                placement="top"
              >
                <button
                  className="monitoring-dashboard-v2__main-content__chat-container__header__actions-container__end-call"
                  onClick={() => {
                    const cdrid = selectedChat.idatendimento;
                    const serverid = selectedChat.serverid;
                    const iduser = selectedChat.monuser;
                    changeDisplayByeChat(cdrid, serverid, iduser, InfoUsers);
                    setSelectedChat(null);
                    setMonitorMessage([]);
                    if (parseInt(selectedChat.idmidia) === 3) {
                      dispatch(deleteEmailMsg(cdrid));
                    }
                  }}
                >
                  <CallRemove />
                </button>
              </Tooltip>
              <Tooltip
                title={<span style={{ fontSize: "12px" }}>Transferir</span>}
                placement="top"
              >
                <button
                  className="monitoring-dashboard-v2__main-content__chat-container__header__actions-container__regular-option"
                  onClick={(event) => {
                    const cdrid = selectedChat.idatendimento;
                    const serverid = selectedChat.serverid;
                    const iduser = selectedChat.monuser;
                    const number = selectedChat.telefone;
                    changeDisplayTransfer(
                      event,
                      cdrid,
                      serverid,
                      iduser,
                      number
                    );
                  }}
                >
                  <IconConsultTransfer />
                </button>
              </Tooltip>
              <Tooltip
                title={<span style={{ fontSize: "12px" }}>Anotações</span>}
                placement="top"
              >
                <button
                  className="monitoring-dashboard-v2__main-content__chat-container__header__actions-container__regular-option"
                  onClick={(event) => {
                    const cdrid = selectedChat.idatendimento;
                    const number = selectedChat.telefone;
                    const cliente = selectedChat.cliente;
                    ViewAnotations(event, number, cliente, cdrid);
                  }}
                >
                  <Anotacoes />
                </button>
              </Tooltip>
              <Tooltip
                title={
                  <span style={{ fontSize: "12px" }}>
                    Pesquisar na conversa
                  </span>
                }
                placement="top"
              >
                <button
                  className="monitoring-dashboard-v2__main-content__chat-container__header__actions-container__regular-option"
                  onClick={() => {
                    setOpenSearch(true);
                  }}
                >
                  <IconSearchChat />
                </button>
              </Tooltip>
              {/* <Tooltip
                                  title={
                                    <span style={{ fontSize: "12px" }}>
                                      Detalhes
                                    </span>
                                  }
                                  placement="top"
                                >
                                  <button
                                    className="monitoring-dashboard-v2__main-content__chat-container__header__actions-container__regular-option"
                                    onClick={() => {
                                      setOpenDetails(true);
                                    }}
                                  >
                                    <InfoCircle />
                                  </button>
                                </Tooltip> */}
              <MoreOptionsPopoverV2
                itemSelected={openDetails ? { id: "details" } : null}
                options={[
                  {
                    id: "details",
                    label: "Ver detalhes",
                    icon: <InfoCircle />,
                  },
                ]}
                onSelect={(optionSelected) => {
                  if (!Boolean(optionSelected)) {
                    return;
                  }
                  if (optionSelected.id === "details") {
                    setOpenDetails(true);
                  }
                }}
              />
            </div>
          )}
        </div>
      )}
      <div className={`chat-search ${openSearch ? "is-active" : ""}`}>
        <div className="search-box-content-input">
          <input
            type="text"
            autoFocus={true}
            onChange={(event) => getTermText(event)}
            value={searchText}
            placeholder="Pesquisar mensagens..."
            className="search-input"
          />

          <div className="block-header__search-box-content-count">
            {searchWord.total === 0 ? searchWord.atual : searchWord.atual + 1}{" "}
            de {searchWord.total}
          </div>
        </div>

        <div className="search-box-content-icon">
          <a
            onClick={(event) => handleKeyUp("less")}
            className="block-header__search-box-icon material-icons"
          >
            expand_less
          </a>
          <a
            onClick={(event) => handleKeyUp("more")}
            className="block-header__search-box-icon material-icons"
          >
            expand_more
          </a>
        </div>
        <button
          onClick={() => {
            setSearchText("");
            setOpenSearch(false);
            setSearchWord({ atual: 0, total: 0 });
          }}
          className="search-box-button"
        >
          <Typography.H5 color={"white"} weight={"700"}>
            Concluir
          </Typography.H5>
        </button>
      </div>

      <div
        className="chat-window"
        key={`id-atendimento--${
          selectedChat ? selectedChat.idatendimento : "null"
        }`}
      >
        {selectedChat ? (
          renderChat()
        ) : (
          <div className="monitoring-dashboard-v2__chat-window__no-chat-selected">
            <DefaultIcon />
          </div>
        )}
      </div>
      {renderInputChat()}
    </div>
  );
};

export default MessageContainer;
